import { EnvironmentState } from "store/slices/environment/slice";

export const ENVIRONMENT: EnvironmentState = {
  REACT_APP_HOST: "",
  REACT_APP_DATADOG_APPLICATION_ID: "",
  REACT_APP_DATADOG_CLIENT_TOKEN: "",
  REACT_APP_BUCKET_BASEURL: "",
  REACT_APP_APOLLO_URI: "",
  REACT_APP_NAMESPACE: "biz-tecma-dev1",
  REACT_APP_INFO_MAIL: "",
  REACT_APP_REPORT_API_BASE_URL: "",
  FEATURE_FLAG_CALENDAR: false,
  REACT_APP_COOKIEBOT_ID: "",
  REACT_APP_CLARITY_ID: "",
  NODE_ENV: "",
  REACT_APP_PRODUCT_CONFIGURATION_API_REST_URI: "",
  REACT_APP_PROJECT_API_REST_URI: "",
  REACT_APP_ASSET_API_REST_URI: "",
  REACT_APP_CLIENT_API_REST_URI: "",
  REACT_APP_API_REST_BASE_URI: "",
  REACT_APP_ERROR_API_ENDPOINT: "",
  REACT_APP_WINSTON_LOG_LEVEL: "",
  REACT_APP_PROJECT_API_BASE_URL: "",
  REACT_APP_SPACE_API_BASE_URL: "",
  REACT_APP_ROOM_SELECTOR_API_BASE_URL: "",
  REACT_APP_API_URI: "",
  REACT_APP_PRODUCT_NAME: "",
  REACT_APP_AWS_API_URI: "",
  REACT_APP_AWS_TOKEN: "ob8n7z3EayXMlhu9dKF01AcC0UPsN0u7cN1z9Hde",
  REACT_APP_TOKEN_EXPIRATION_THRESHOLD: "",
};

export const setEnvironment = (environment: EnvironmentState) => {
  Object.assign(ENVIRONMENT, environment);
};
